export default __webpack_public_path__ + "svg/CompaniesLogos/logo_microsoft.svg?daf4fa76";